import { Injectable } from '@angular/core';
import { AdsService } from '../ads-manager/ads-service';
import { Events } from '../../providers/events/events';
/*
  Generated class for the TimeManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TimeManagerProvider {
  public static timeHolder;
  public seconds = 0;
  constructor(public events: Events) {
  }
  public startTimer() {
    this.stopTimer();
    this.stopTimer();
    // TimeManagerProvider.timeHolder = setInterval(
    //   () => {
    //     this.seconds += 3;
    //     this.events.publish("checkOnline");
    //     if (this.seconds % AdsManagerProvider.adsTimePeriod == 0) {
    //       this.events.publish("presentAd");
    //       this.events.publish("ping");
    //     }
    //   }, 50000);
  }
  public stopTimer() {
    clearInterval(TimeManagerProvider.timeHolder);
  }

}
